import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
//@ts-ignore
import VueRouteMiddleware from "vue-route-middleware";
import guest from "@/router/guest";
import AuthMiddleware from "@/middlewares/AuthMiddleware";
import Home from "@/views/Home.vue";
import users from "@/router/users";
import pages from "@/router/pages";

const routes: Array<RouteRecordRaw> = [
  ...guest,
  ...users,
  ...pages,
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      middleware: [AuthMiddleware],
      title: "route.home",
      breadcrumbs: [{ name: "Home", label: "route.home" }],
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach(VueRouteMiddleware());

export default router;
